var DEFAULT_ERROR_MESSAGE = 'Введите кадастровый номер';
var CADASTRAL_NUMBER_REGEXP = /^\d{2}:\d{2}:\d{4,7}:\d{1,35}$/;
var hasValidFormat = function hasValidFormat(value) {
  return CADASTRAL_NUMBER_REGEXP.test(value);
};
var INVALID_CHARACTERS_ERROR_MESSAGE = 'Кадастровый номер может состоять только из цифр и символа ":"';
var INVALID_CHARACTERS_REGEXP = /[^\d:]/;
var hasInvalidCharacters = function hasInvalidCharacters(value) {
  return INVALID_CHARACTERS_REGEXP.test(value);
};
var validCadastralNumber = function validCadastralNumber(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? DEFAULT_ERROR_MESSAGE : _c,
    _d = _b.invalidCharactersMessage,
    invalidCharactersMessage = _d === void 0 ? INVALID_CHARACTERS_ERROR_MESSAGE : _d;
  return function (value) {
    if (value === void 0) {
      value = '';
    }
    var trimmedValue = value.trim();
    if (!trimmedValue) {
      return message;
    }
    if (hasInvalidCharacters(value)) {
      return invalidCharactersMessage;
    }
    if (!hasValidFormat(value)) {
      return message;
    }
    return;
  };
};
export default validCadastralNumber;
export { DEFAULT_ERROR_MESSAGE, validCadastralNumber };